import { useResizedImageEnhanced } from "../../../../../../hooks/useResizedImageEnhanced";
import { PresentationsItem, SelectRing } from "../styles";
import { getFileUrl } from "../../../../../../actions/getFileUrl";
import React from "react";
export var SelectablePresentation = function (_a) {
    var project = _a.project, selected = _a.selected, onSelect = _a.onSelect;
    var _b = useResizedImageEnhanced(project === null || project === void 0 ? void 0 : project.titleImages), image = _b[0], containerRef = _b[1];
    if (!project)
        return null;
    return React.createElement(PresentationsItem, { ref: containerRef },
        React.createElement("img", { style: { width: '100%', height: '100%', objectFit: 'cover', pointerEvents: 'none', userSelect: 'none' }, src: getFileUrl() + '/' + (image === null || image === void 0 ? void 0 : image.url) || undefined, alt: '' }),
        React.createElement(SelectRing, { active: selected, onClick: function (ev) {
                if (onSelect) {
                    onSelect();
                }
            } }, selected && (React.createElement("div", null,
            React.createElement("svg", { width: '12', height: '10', viewBox: '0 0 12 10', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
                React.createElement("path", { d: 'M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966\n    4.02557L1 4.85653Z', fill: '#FEFEFE', stroke: 'black' }))))));
};
//# sourceMappingURL=selectablePresentation.js.mapimport { useResizedImageEnhanced } from "../../../../../../hooks/useResizedImageEnhanced";
import { PresentationsItem, SelectRing } from "../styles";
import { getFileUrl } from "../../../../../../actions/getFileUrl";
import React from "react";
export var SelectablePresentation = function (_a) {
    var project = _a.project, selected = _a.selected, onSelect = _a.onSelect;
    var _b = useResizedImageEnhanced(project === null || project === void 0 ? void 0 : project.titleImages), image = _b[0], containerRef = _b[1];
    if (!project)
        return null;
    return React.createElement(PresentationsItem, { ref: containerRef },
        React.createElement("img", { style: { width: '100%', height: '100%', objectFit: 'cover', pointerEvents: 'none', userSelect: 'none' }, src: getFileUrl() + '/' + (image === null || image === void 0 ? void 0 : image.url) || undefined, alt: '' }),
        React.createElement(SelectRing, { active: selected, onClick: function (ev) {
                if (onSelect) {
                    onSelect();
                }
            } }, selected && (React.createElement("div", null,
            React.createElement("svg", { width: '12', height: '10', viewBox: '0 0 12 10', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
                React.createElement("path", { d: 'M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966\n    4.02557L1 4.85653Z', fill: '#FEFEFE', stroke: 'black' }))))));
};
//# sourceMappingURL=selectablePresentation.js.map